<template>
  <v-container grid-list-sm text-xs-left>
    <v-layout wrap row>
      <v-btn
          icon
          @click="navigate('*goBack*')"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-flex class="py-2 headline">
        News Details
      </v-flex>
      <v-flex xs12 class="px-4 subheading">
        <span v-if="newFlag" class="subheading">Here you can create a news</span>
        <span v-else class="subheading">Here you can update a news</span>
      </v-flex>
    </v-layout>
    <v-form ref="form">
      <v-layout row wrap pa-2>

        <v-flex xs12 pa-3>
          <v-textarea
              v-model="news.title"
              name="Title"
              label="Insert here the title"
              :rules="rules.title"
              :counter="200"
              border-radius="20px"
              rows="1"
              box
              auto-grow
              class="subheading"
              @blur="sanitize($event,'Title')"
          />
        </v-flex>

        <v-flex xs12 pa-3>
          <DescriptionCreator
              :contentProp="news.content"
              @onTextWritten="textContent"
          >
          </DescriptionCreator>
        </v-flex>

        <v-flex xs12 pa-3>
          <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="news.date"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
          >
            <template v-slot:activator="{ on }" v-if="news.published">
              <v-text-field
                  v-model="news.publicationDate"
                  label="Date (YYYY-MM-DD)"
                  prepend-inner-icon="event"
                  readonly
                  hide-details
                  v-on="on"
                  box
              ></v-text-field>
            </template>
            <!--<v-date-picker
                v-model="news.date"
                scrollable
            >
              <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="checkDate(news.date)">OK</v-btn>
            </v-date-picker>-->
          </v-menu>
        </v-flex>

        <v-flex xs12 pa-3>
          <v-textarea
              v-model="news.author"
              name="Author"
              label="Insert here the author"
              :rules="rules.author"
              :counter="200"
              border-radius="20px"
              rows="1"
              box
              auto-grow
              class="subheading"
              @blur="sanitize($event,'author')"
          />
        </v-flex>


        <v-flex xs12 pa-3>
          <FileInputChallenge
              ref="fileInputChallenge"
              label="Upload an image (max 5 MB)"
              accept=".jpg,.jpeg,.png"
              :sourceImg="image"
              required
              @update="imgUploaded"
          />
          <v-img
              :src="image"
              max-height="200px"
              contain
          ></v-img>
        </v-flex>

        <v-flex xs12 pa-3>
          <v-btn v-if="newFlag" round dark color="blue" @click="update('CREATE')">
            Create
          </v-btn>
          <v-btn v-else-if="!news.toApprove" round dark color="blue" @click="update()">
            Update
          </v-btn>
          <v-btn v-else round dark color="red" @click="update('REJECT')">
            Reject
          </v-btn>
          <v-btn v-if="!newFlag && !news.published && !news.toApprove && user.role !== 'APPROVER_INNOVATION'" round dark color="green" @click="update('SUBMIT')">
            Submit
          </v-btn>
          <v-btn v-if="!newFlag && !news.published && !news.toApprove && user.role === 'APPROVER_INNOVATION'" round dark color="green" @click="update('PUBLISH')">
            Publish
          </v-btn>
          <v-btn v-if="!newFlag && !news.published && news.toApprove" round dark color="green" @click="update('PUBLISH')">
            Publish
          </v-btn>
          <v-btn v-if="!newFlag && news.published && !news.toApprove" round dark color="green" @click="update('UNPUBLISH')">
            Unpublish
          </v-btn>
        </v-flex>

        <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            color="error"
            top
        >
          {{snackbarText}}
          <v-btn
              color="white"
              flat
              @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import RouterService from "@/helpers/RouterService";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
import TimeService from "@/helpers/TimeService";
import UrlsService from "@/helpers/UrlsService";
import FileInputChallenge from "@/components/Inputs/FileInputChallenge";
import DescriptionCreator from "@/pages/Admin/Innovation/ChallengeManagement/DescriptionCreator";
import {mapGetters, mapState} from "vuex";
import {values} from "@/utils/values"

export default {
  name: "NewsDetails",
  components: {DescriptionCreator, FileInputChallenge,},
  props: {
    _id: String,
    newFlagProp: Boolean,
  },
  computed: {
    ...mapState({}),
    ...mapGetters("UserState", {
      user: "getUserInfo",
    }),
  },
  data() {
    return {
      rules: {
        title: [v => v.length <= 200 || 'Title must be less than 200 characters'],
        author: [v => v.length <= 200 || 'Author must be less than 200 characters',value => {
          const pattern = /[^\w."%!;\\\/àèéìòù$£€*?§@ç°()_:|=&^+#',\s -]+/gm
          return value === '' || value === '-' || !pattern.test(value) || 'No special characters are allowed'}],

      },
      news: {
        title: "",
        content: "",
        creationDate: "",
        publicationDate: "",
        author: "",
        published: false,
        toApprove: false,
        createdBy: "",
      },
      image: values.placeholderImgBase64,
      menu: false,
      snackbar: false,
      snackbarText: "",
      timeout: 6000,
      newFlag: false,
    }
  },
  created() {
    this.newFlag = this.newFlagProp;
    if(this._id !== "newNews"){
      this.getNews();
    }
    else {
      this.newFlag = true;
      this.news.author = this.user.name.concat(" ",this.user.surname);
    }
  },
  methods: {
    sanitize(event,variableName) {
      event.preventDefault();
      this["news"][variableName] = this.$sanitize(event.target.value)
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    navigate(path) {
      RouterService.goTo(path);
    },
    getNews(){
      let requestUrl = {
        url: UrlsService.newsOperation,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          text: "GET_BY_ID",
          newsRequest: {
            news: {
              _id: this._id,
            }
          },
        }
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "News",
        loading: "Waiting for news...",
        error: "Cannot get news...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            let tmp = {};
            let responseNews = responseSuccess.response.news[0];
            Object.keys(responseNews).forEach(function(key,_) {
              if (key !== 'image') {
                tmp[key] = responseNews[key];
              }
            });
            this.news = tmp;
            this.image = responseNews['image'];
          });
    },
    update(operation="UPDATE"){
      let check = this.checkNews()

      switch (check) {
        case 'errorForm':
          this.snackbar = true;
          this.snackbarText = "There's an error in a field!";
          break;
        case 'errorTitle':
          this.snackbar = true;
          this.snackbarText = "Insert the title";
          break;
        case 'errorContent':
          this.snackbar = true;
          this.snackbarText = "Insert the content";
          break;
        case 'errorAuthor':
          this.snackbar = true;
          this.snackbarText = "Insert the author";
          break;
        case 'errorImgBase64':
          this.snackbar = true;
          this.snackbarText = "Insert the image";
          break;
        default:
          //this.news["createdBy"] = this.user.email
          if (operation==="PUBLISH") {
            this.news.publicationDate = new Date().toISOString().substr(0, 10);
          }
          else if (operation === "CREATE") {
            this.news.creationDate = new Date().toISOString().substr(0, 10);
            this.news.createdBy = this.user.email;
          }

          let requestUrl = {
            url: UrlsService.newsOperation,
            timeout: TimeService.secondsToMillis(0),
          };
          let requestData = {
            interactionData: {
              text: operation,
              newsRequest: {
                news: this.news,
                image: this.image,
              }
            },
          };
          let requestObject = {
            type: "normal",
            urlsInfo: requestUrl,
            data: {
              data: requestData,
            },
          };
          let messages = {
            title: "News",
            loading: "Waiting for news update...",
            error: "Cannot get news update...",
          };
          let options = {
            loadingType: "fullscreen",
            timeout: TimeService.secondsToMillis(0),
          };
          APILoaderDecoratorService.setLoader(requestObject, messages, options)
              .then(responseSuccess => {
                this.navigate('*goBack*');
              });

      }
    },
    checkNews(){
      if(!this.$refs.form.validate()) return "errorForm";
      if(this.news.title === "") return "errorTitle";
      if(this.news.content === "") return "errorContent";
      if(this.news.author === "") return "errorAuthor";
      if(this.image === values.placeholderImgBase64) return "errorImgBase64";
      //if(this.news.date < new Date().toISOString().substring(0,10)) return "errorDate";

      return "noError"
    },
    /*checkDate(date){
      if(date < new Date().toISOString().substring(0,10)){
        this.snackbar = true
        this.snackbarText = "Date can't be placed in the past."
      } else{
        this.$refs.menu.save(date)
      }
    },*/
    imgUploaded(newValue){
      this.image = newValue
    },
    textContent(newValue){
      this.news.content = newValue
    },
  }

}
</script>

<style scoped>

</style>
